export const SET_SQUARE_INFO = "SET_SQUARE_INFO";

export function setSquareInfo(payload) {
  return {
    type: SET_SQUARE_INFO,
    payload
  };
}
